import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import http from "../../../../services/http.service";
import { toast } from "react-toastify";

const MANAGE_USER = `/invite`;
const INVITE_DETAILS = '/invite-details';

export const getInviteUserList = createAsyncThunk(
  "getInviteUserList",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(MANAGE_USER);
      return response.data.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const sendUserInvite = createAsyncThunk(
  "sendUserInvite",
  async (values: any, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${MANAGE_USER}`, values);
      toast.success(response?.data?.message || "Invite sent Successfully. Please check your Email.");
      dispatch(getInviteUserList({}));
      return response?.data;
    }
    catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to send invite");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const archiveUser = createAsyncThunk(
  "archiveUser",
  async ({ uuid, archieve }: { uuid: string; archieve: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.put(`${MANAGE_USER}/${uuid}`, { archieve });
      toast.success(response?.data?.message);
      dispatch(getInviteUserList({}));
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to archive user");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteInvitedUser = createAsyncThunk(
  "deleteInvitedUser",
  async ({ uuid }: { uuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.delete(`${MANAGE_USER}/${uuid}`);
      dispatch(getInviteUserList({}));
      toast.success(response?.data?.message);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to delete user");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getInvitedUserDetails = createAsyncThunk(
  "getInvitedUserDetails",
  async ({ uuid }: { uuid: string }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.get(`${INVITE_DETAILS}/${uuid}`);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        // toast.error(error?.response?.data?.error || "Failed to get user details");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);

export const acceptUserInvitation = createAsyncThunk(
  "acceptUserInvitation",
  async ({ uuid, values }: { uuid: string, values: any }, { rejectWithValue, dispatch }) => {
    try {
      const response = await http.post(`${INVITE_DETAILS}/${uuid}`, values);
      return response.data;
    } catch (error: any) {
      if (error instanceof AxiosError) {
        toast.error(error?.response?.data?.error || "Failed to accept invitation");
        return
      }
      return rejectWithValue(error.message);
    }
  }
);